import { useEffect, useRef, useState } from "react";

/**
 * Fade-in + soft rise on scroll into view (IntersectionObserver).
 * - Premium, no excessive movement
 * - Disconnect after first reveal
 */
export default function Reveal({ children, className = "", delay = 0, as: As = "div", ...rest }) {
  const ref = useRef(null);
  const [shown, setShown] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    if (typeof IntersectionObserver === "undefined") { setShown(true); return; }
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setShown(true);
            io.disconnect();
          }
        });
      },
      { threshold: 0.15, rootMargin: "0px 0px -8% 0px" },
    );
    io.observe(el);
    return () => io.disconnect();
  }, []);

  return (
    <As
      ref={ref}
      className={`${className} will-change-[opacity,transform] ${shown ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}
      style={{
        transitionProperty: "opacity, transform",
        transitionDuration: "900ms",
        transitionTimingFunction: "cubic-bezier(0.22, 1, 0.36, 1)",
        transitionDelay: `${delay}ms`,
      }}
      {...rest}
    >
      {children}
    </As>
  );
}
